/* eslint-disable semi */

/* eslint-disable semi */
// 依存 async-validator
import Schema from 'async-validator';
import * as coreRules from '../rules';

const debug = process.env.NODE_ENV === 'development';

/**
 * メッセージテンプレートを上書きする
 */
function overrideMessages (noLabel, src, dist) {
  Object.keys(src).forEach(key => {
    const srcVal = src[key];

    if (typeof srcVal === 'string') {
      // ラベル非表示モードの場合は先頭にエラー文字列操作用のマークを付与する
      dist[key] = (noLabel ? '%s:__::' + srcVal : srcVal) + '::__:';
    } else {
      overrideMessages(noLabel, srcVal, dist[key]);
    }
  });
}

/**
 * エラーメッセージの補正を行う
 *
 * デフォルトの挙動では項目名等がメッセージに必ず記載されてしまう。
 * 特定文字（:__::,::__:）の前後を無視する仕組みを設けることで、
 * メッセージをテンプレート側でコントロールできるようにします。
 * 尚、埋込順については、コントロールできない。
 */
function filterMessage (errors, fields) {
  if (errors !== null) {
    errors.forEach(error => {
      error.message = error.message
        .replace(/^.*:__::/, '')
        .replace(/::__:.*$/, '');
    });
  }
  return [errors, fields];
}

/**
 * async-validatorのカスタマイズクラス
 *
 * メッセージの形式を補正します（項目名を含まない形式のメッセージに対応）
 */
const AsyncValidatorAlterer = {
  invoke (options = {}) {
    if (debug) {
      console.debug('CustomizeAsyncValidator was activated.');
    }

    const noLabel = options.noLabel || false;
    const messages = options.messages || {};
    const rules = options.rules || {};

    // メッセージを設定する
    overrideMessages(noLabel, messages, Schema.messages);

    // Schemaに対しエラーメッセージの補正処理を追加する
    // :__::より左
    // ::__:から右の文字列は無視する。
    const validate = Schema.prototype.validate;
    Schema.prototype.validate = function (...args) {
      const callback = args[2];
      args[2] = function (errors, fields) {
        callback.apply(this, filterMessage(errors, fields));
      };
      return validate.apply(this, args);
    };

    // カスタムバリデーションを追加する
    Object.keys(coreRules).forEach(name => {
      Schema.register(name, coreRules[name]);
    });
    Object.keys(rules).forEach(name => {
      Schema.register(name, rules[name]);
    });
  }
};
export default AsyncValidatorAlterer;



// WEBPACK FOOTER //
// ./src/core/libs/AsyncValidatorAlterer.js